module.exports = __webpack_public_path__ + "static/3-34f2ed38f558b813eb7b13a3b9a2c90c.png";